/**
 * Schéma de style des Onglets (cf. shared/theme/styleSchema) : ce qu'un style
 * du thème pose, et les valeurs de départ du bloc. Un style du thème règle
 * tout ce que règle l'inspecteur hors contenu : marges, alignement de la
 * barre et animation compris.
 */
export const TABS_STYLE_SCHEMA = {
  variant: { default: 'default' },
  accentColor: { default: '' },
  paddingTop: { style: 'theme' },
  paddingBottom: { style: 'theme' },
  paddingX: { style: 'theme' },
  marginBottom: { style: 'theme', seed: true },
  listAlign: { style: 'theme' },
  appearAnimation: { style: 'theme' },
  appearAnimationDuration: { style: 'theme' },
  textStyles: { style: 'theme' },
};
